import type { ClimbScan, ClimbScanColor } from '../../../types/climb-scan';
import type { ScanColorPreview } from './ScanColorPreviews';

/**
 * The climbs worth previewing on a scan's photo: the ones still to be done.
 *
 * **Only while nothing is open.** With a climb selected the photo shows that
 * climb's holds and nothing else — the rest of the wall would be rings over the
 * marks being drawn, which is exactly what the setter is trying to read. So the
 * previews are what the photo says when it is not yet showing a climb: here is
 * what is on this wall, press one to start.
 */
export function previewsForScan(scan: ClimbScan, selectedColorId: string | null): ScanColorPreview[] {
  if (selectedColorId) return [];

  return scan.colors
    .filter((color) => color.status !== 'completed')
    .filter((color) => color.detected_holds.length > 0)
    .map(toPreview);
}

function toPreview(color: ClimbScanColor): ScanColorPreview {
  return {
    colorId: color.id,
    label: color.climb?.name || color.climb_name || color.color_name || '',
    hex: color.hex_colors?.[0] ?? null,
    holds: color.detected_holds,
  };
}
